<template>
  <div class="modal-wrap" ref="modal" v-show="show">
    <div class="modal-cover" @click="handleCoverClick"></div>

    <div class="modal" :class="notShadow?'notShadow':''">
      <div class="modal-content">
        <slot name="modal-content" />
      </div>
      <div
        class="close"
        v-if="showClose"
        @click="handleCloseBtnClick()"
      ></div>
    </div>

    <span class="back" v-show="showBack" @click="handleBackClick" />
  </div>
</template>

<script>
import pageScrollCtrl from '../js/page-scroll-ctrl';

const Modal = {
  name: 'Modal',
  props: {
    // 弹窗对应的关闭 flag
    name: {
      type: String
    },
    // 点击背景是否可以关闭
    coverCloseable: {
      type: Boolean,
      default: true
    },
    // 是否展示返回按钮
    showBack: {
      type: Boolean,
      default: false
    },
    // 是否展示关闭按钮
    showClose: {
      type: Boolean,
      default: false
    },
    // 关闭按钮处理函数
    closeBtnHandler: {
      type: Function
    },
    // 点击 cover 处理
    coverHandler: {
      type: Function
    },
    // 弹框盒子的阴影消除
    notShadow: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    /**
     * 关闭通用处理
     * */
    handleClose() {
      this.$emit('modalClose');
    },
    /**
     * 处理点击蒙层处理
     * */
    handleCoverClick() {
      if (!this.coverCloseable) {
        return false;
      }

      if (this.coverHandler) {
        this.coverHandler();
        return false;
      }
      this.$emit('modalClose', 'cover');
    },
    /**
     * 处理一下关闭按钮
     */
    handleCloseBtnClick() {
      if (this.closeBtnHandler) {
        this.closeBtnHandler();
        return false;
      }
      this.$emit('modalClose', 'closeBtn');
    },
    /**
     * 处理返回
     */
    handleBackClick() {
      this.$emit('modalBack', 'back');
    },
    /**
     * 弹窗定位
     */
    resizePosition() {
      const scrollTop = document.documentElement.scrollTop || document.body.scrollTop || 0;
      const { modal } = this.$refs;
      modal.style.top = `${scrollTop}px`;
    }
  },
  data() {
    return {
      show: true,
      scrollTop: -1
    };
  },
  mounted() {
  },
  beforeCreate() {
    pageScrollCtrl.lock('modal');
  },
  beforeDestroy() {
    pageScrollCtrl.unlock('modal');
  }
};

export default Modal;
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@import "../css/common-mixin";

.modal-content {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}

.modal-wrap {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  overflow: hidden;
  z-index: 109;

  .modal-cover {
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: transparent;
  }

  .back {
    opacity: 0;
    position: absolute;
    top: rpx(30px);
    left: rpx(40px);
    width: rpx(21px);
    height: rpx(38px);
    // background: url("../../assets/modal/back-btn.png") center no-repeat;
    background-size: 100% 100%;
    animation: fadeIn 0.1s 0.4s linear forwards;
  }
}

.modal {
  position: absolute;
  left: 0;
  bottom: 0;
  top: 0;
  right: 0;
  margin: auto;
  width: rpx(725px);
  height: rpx(1092px);
  width: 100%;
  height: 100%;
  border-radius: rpx(20);
  box-shadow: 0 0 rpx(10) rgba(0, 0, 0, 0.1);
  background-size: 100% 100%;
  // transform: scale(0.9);
  &.notShadow{
    box-shadow: 0 0 0;
  }
  .close {
    position: absolute;
    top: rpx(994px);
    left: rpx(310px);
    width: rpx(107px);
    height: rpx(107px);
    background: url("../../assets/modal/close-bottom.png") center no-repeat;
    background-size: 100% 100%;
    transform: scale(0.7);
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
</style>
